export default __webpack_public_path__ + "static/media/cushion.ea0cb9da.webp";